/** Сохраняет паспорт проекта при уходе фокуса из его полей. */
import { apiHooks } from "@/api";
import { useAuthStore, useProjectStore } from "@/shared/store";
import { putLocalProject } from "./localProjectCache";

export const useSaveProjectMetadata = (projectId: string | null) => {
	const updateProject = apiHooks.projects.useUpdateProject();
	return async () => {
		const { project, demo } = useProjectStore.getState();
		if (
			demo ||
			projectId === null ||
			project.id !== projectId ||
			!useAuthStore.getState().isAuthenticated
		)
			return;
		const lastModifiedDate = new Date().toISOString();
		await putLocalProject({
			lastModifiedDate,
			project,
			projectId,
			syncStatus: "pending",
		});
		if (!navigator.onLine) return;
		await updateProject.execute(
			{ id: projectId },
			{ description: project.description || null, name: project.name },
		);
	};
};
